export function buildVerifyCompanyNcmRows(dataPrepared: any) {
  const rows = Array.isArray(dataPrepared)
    ? dataPrepared
    : [];

  return rows.map((row: any) => ({
    GTIN: row.GTIN ?? '',
    Descrição: row.DESCRICAO ?? '',
    'Tipo GTIN': row.TIPO_GTIN ?? '',
  }));
}
